<template>
    <!-- 兑换活动管理-详情 -->
    <div class="exchangeGroupOrderDetail">
        <content-view>
            <div slot="header" class="ml16">
                <div class="font-biggest font-bold mb8 text-color-85">{{dataDetail.couponName}}</div>
                <div class="mb8 flex flex-space-between">
                    <section>
                        <span class="mr80">创建用户：{{dataDetail.createUser}}</span>
                        <span>创建时间：{{dataDetail.createTime}}</span>
                    </section>
                    <a-row style="width: 50%;text-align: center"> 
                        <a-col :span="8">
                            <span class="text-color-45">订单金额</span>
                            <div class="font-bigger text-color-85">{{$utils.toFixed(orderDetail.saleTotal, 2)}}</div>
                        </a-col>
                        <a-col :span="8">
                            <span class="text-color-45">销售数量</span>
                            <div class="font-bigger text-color-85">{{orderDetail.saleNum ? orderDetail.saleNum.toLocaleString() : 0}}</div>
                        </a-col>
                        <a-col :span="6">
                            <span class="text-color-45">兑换数量</span>
                            <div class="font-bigger text-color-85">{{orderDetail.cashNum ? orderDetail.cashNum.toLocaleString() : 0}}</div>
                        </a-col>
                    </a-row>
                </div>
                <a-tabs :defaultActiveKey="activeKey" @change="callback">
                    <a-tab-pane :key="1" tab="概览"></a-tab-pane>
                    <a-tab-pane v-if="!$route.query.showDetail" :key="2" tab="兑换明细"></a-tab-pane>
                    <a-tab-pane v-if="!$route.query.showDetail" :key="3" tab="操作记录"></a-tab-pane>
                </a-tabs>
            </div>
            <div v-if="activeKey == 1">
                <a-card title="基础信息">
                    <a-row class="mb16">
                        <a-col :span="8">客户名称：{{orderDetail.consumerName}}</a-col>
                        <a-col :span="8">展示名称：{{orderDetail.goodName}}</a-col>
                        <a-col :span="8">销售人员：{{orderDetail.saleMan}}</a-col>
                    </a-row>
                    <a-row class="mb16">
                        <a-col :span="8">销售门店：{{orderDetail.saleShopName}}</a-col>
                        <a-col :span="8">销售日期：{{orderDetail.saleDate}}</a-col>
                        <a-col :span="8">
                            <div>销售类型
                                <a-tooltip>
                                    <span slot="title">
                                        • 预付款：根据售卖数量计算订单价格；<br>
                                        • 后付款：根据实际兑换数量计算订单价格；<br>
                                        • 赠送：订单价格计为0.00;
                                    </span>
                                    <a-icon type="question-circle-o" />
                                </a-tooltip>
                                ：{{['赠送','后付费','预付费'][orderDetail.saleType]}}
                            </div>
                        </a-col>
                    </a-row>
                    <a-row class="mb16">
                        <a-col :span="8">销售数量：{{orderDetail.saleNum}}</a-col>
                        <a-col :span="8">销售单价（元）：{{$utils.toFixed(orderDetail.salePrice, 2)}}</a-col>
                        <a-col :span="8"></a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="24">备注：{{orderDetail.remark}}</a-col>
                    </a-row>
                </a-card>
                <exchange-goods class="mt24" title="商品信息" :goodsDetail="dataDetail" :goodsId="dataDetail.goodId" :goodsType="dataDetail.goodCategory">
                    <div class="exchangeGroupOrderDetail-tips mb16">
                        <span>兑换ID: </span>
                        <span>{{dataDetail.couponId}};</span>
                        <span>兑换礼券名称：</span>
                        <span>{{dataDetail.couponName}}；</span>
                        <span>兑换有效期：</span>
                        <span v-if="dataDetail.isHasExpiryDate == 0">不限期；</span>
                        <span v-else-if="dataDetail.isHasExpiryDate == 1">{{dataDetail.startExpiryDate}} ~ {{dataDetail.endExpiryDate}}；</span>
                        <span v-else>-；</span>
                        <span>兑换礼券状态：</span>
                        <span>{{dataDetail.status == '-1' ? '停用' : '正常'}}；</span>
                        <span>是否享受买赠：</span>
                        <span>{{["否", "是"][dataDetail.isHasBuyGet]}}；</span>
                    </div>
                </exchange-goods>
                <a-card
                    :bordered="false"
                    title="发售方式"
                    class="mt24"
                >
                    <div class="mb16">
                        <span class="mr8">商品兑换方式:&nbsp;
                            <a-tooltip>
                                <span slot="title">
                                    • 一物一码：每个商品都有唯一的兑换码，兑完即失效；<br>
                                    • 通用码：公用的兑换码，兑换数量超过销售数量即失效
                                </span>
                                <a-icon type="question-circle-o"/>
                            </a-tooltip>：{{['一物一码','通用码'][orderDetail.convertType]}}
                        </span>
                    </div>
                    <div>
                        <span>发放形式&nbsp; 
                        <a-tooltip>
                            <span slot="title">
                                兑换礼券发给客户的方式，可多选：<br>
                                • 实体券：通过实体票券介质发给客户；<br>
                                • CSV：以CSV电子表格形式发给客户，由其自行分发或导入系统；<br>
                                • 二维码：以二维码图片形式发给客户，由其自行分发；<br>
                                • 账户直发：提供客户手机号名单，直接将礼券发到客户阿派朗账户；<br>
                                • 短信发送：提供客户手机号名单，将兑换码发到指定手机号；<br>
                                • 邮件推送：提供客户邮件名单，将兑换码发到指定邮件；<br>
                                • 在线链接：生成H5在线链接，供客户在线主动领取或兑换；<br>
                                • API接口：提供对应接口信息，供客户通过接口调用兑换码；
                            </span>
                            <a-icon type="question-circle-o" />
                        </a-tooltip>：
                        </span>
                        <a-card class="pt24 pb24" :bordered="false">
                            <a-card-grid v-for="(item, index) in orderDetail.couponGroupOrderSendsList" :key="index" class="exchangeGroupOrderDetail-exchangeMode mr8 mb8 text-center">
                                <div class="font-bigger">{{exchangeMode[item.sendType].name}}</div>
                                <span class="font-smaller">{{exchangeMode[item.sendType].tips}}</span>
                            </a-card-grid>
                        </a-card>
                    </div>
                </a-card>
                <a-card
                    :bordered="false"
                    title="附件"
                    class="mt24"
                >
                    <p v-for="(item, index) in orderDetail.couponGroupOrderFileList" :key="index"><a target="_blank" :href="item.url">{{item.name}}</a><br></p>
                </a-card>
            </div>
            <div v-if="activeKey == 2">
                <a-card>
                    <a-form :form="form" layout="inline" class="store-one-form">
                        <a-form-item label="序列号SN">
                            <a-input placeholder="请输入" v-decorator="['sn']"></a-input>
                        </a-form-item>
                        <a-form-item label="兑换码状态">
                            <a-select allowClear placeholder="请选择" v-decorator="['isUse']">
                                <a-select-option value="1">已兑换</a-select-option>
                                <a-select-option value="0">未兑换</a-select-option>
                                <a-select-option value="-1">已禁用</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="兑换方式">
                            <a-select allowClear placeholder="请选择" v-decorator="['useType']">
                                <a-select-option :value="0">通用码</a-select-option>
                                <a-select-option :value="1">一物一码</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="兑换手机号">
                            <a-input placeholder="请输入" v-decorator="['useUser']"></a-input>
                        </a-form-item>
                        <a-form-item label="兑换日期">
                            <a-range-picker
                                style="width:282px"
                                format="YYYY－MM－DD"
                                v-decorator="['validity']"
                            />
                        </a-form-item>
                        <a-form-item class="wrap-header-button">
                            <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                            <a-button @click="handleReset">重置</a-button>
                        </a-form-item>
                    </a-form>
                </a-card>
                <a-card class="mt24">
                    <div slot="extra">
                        <a-button @click="disableOrOpenBatch(-1)">批量禁用</a-button>
                        <a-button @click="disableOrOpenBatch(0)">批量解禁</a-button>
                        <a-button @click="exprotExcel">导出</a-button>
                        <a-button @click="exprotExcelAll">全部导出</a-button>
                    </div>
                    <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    :rowKey="record => record.id"
                    :rowSelection="{type: 'checkbox', onChange: tableSelectChange, selectedRowKeys: tableSelectedRowKeys}"
                    @change="changePage"
                    >
                        <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                        <span slot="status" slot-scope="status,row">{{row.status == -1 ? '已禁用' : (row.isUse ? '已兑换' : '未兑换')}}</span>
                        <span slot="useType" slot-scope="useType">{{['通用码','一物一码'][useType] || '-'}}</span>
                        <span slot="empty" slot-scope="empty">{{empty || '-'}}</span>
                        <span slot="validityStart" slot-scope="a,row">{{row.validityStart ? (row.validityStart + '~' + row.validityEnd) : '不限期'}}</span>
                        <span slot="action" slot-scope="a,row">
                            <a class="text-primary" @click="disableOrOpen(row.status == -1 ? 0 : -1,row.id, row.groupId)">{{row.isUse == 1 ? '' : (row.status ? '解禁' : '禁用')}}</a>
                        </span>
                    </a-table>
                </a-card>
            </div>
            <div v-if="activeKey == 3">
                <a-card>
                    <a-table
                    bordered
                    :dataSource="dataDownloadList"
                    :columns="columnsDown"
                    :pagination="pagination2"
                    :rowKey="record => record.id"
                    @change="changePage2"
                    >
                        <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                    </a-table>
                </a-card>
            </div>
            <a-modal :title="operateTitle" centered v-model="visable" @cancel="visable = false; remark = undefined">
                <a-alert :message="warningText" banner />
                <a-row class="mt16">
                    <a-col :span="3"><span class="text-fail">*</span> 备注：</a-col>
                    <a-col :span="21"><a-textarea v-model="remark" placeholder="请输入备注" /></a-col>
                </a-row>
                <template slot="footer">
                    <a-button @click="visable = false; remark = undefined">
                    取消
                    </a-button>
                    <a-button type="primary" :disabled="!remark" :loading="btnLoading" @click="handleOk">
                    确定
                    </a-button>
                </template>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import exchangeAccount from "@/components/modules/change-code/exchange-account.component";
    import exchangeGoods from "@/components/modules/change-code/exchange-goods.component";
    import exchangeOutline from "@/components/modules/change-code/exchange-outline.component";

    const columns = [
        {
            title: "序列号SN",
            dataIndex: "sn",
        },
        {
            title: "兑换码状态",
            dataIndex: "status",
            scopedSlots: { customRender: "status" }
        },
        {
            title: "兑换方式",
            dataIndex: "useType",
            scopedSlots: { customRender: "useType" }
        },
        {
            title: "兑换手机号",
            dataIndex: "useUser",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "兑换时间",
            dataIndex: "useTime",
            scopedSlots: { customRender: "empty" }
        },
        // {
        //     title: "团购订单号",
        //     dataIndex: "groupId",
        //     scopedSlots: { customRender: "empty" }
        // },
        // {
        //     title: "团购客户名",
        //     dataIndex: "groupName",
        //     scopedSlots: { customRender: "empty" }
        // },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    const columnsDown = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "操作时间",
            dataIndex: "operationTime"
        },
        {
            title: "操作动作",
            dataIndex: "operationAction",
        },
        {
            title: "操作内容",
            dataIndex: "operationContent",
        },
        {
            title: "备注",
            dataIndex: "remark",
        },
        {
            title: "操作人",
            dataIndex: "operator",
        }
    ];
    export default {
        name: "exchangeGroupOrderDetail",
        components: {
            exchangeAccount,
            exchangeGoods,
            exchangeOutline,
        },
        props: {},
        data() {
            return {
                exchangeMode: [
                    {},
                    {
                        sendType: 1,
                        name: "实体券",
                        tips: "线下实体卡或券",
                        used: true,
                        isSelect: false,
                    },
                    {
                        sendType: 2,
                        name: "CSV文件",
                        tips: "发放电子表格",
                        used: true,
                        isSelect: false,
                    },
                    {
                        sendType: 3,
                        name: "二维码",
                        tips: "发放二维码图片",
                        used: true,
                        isSelect: false,
                    },
                    {
                        sendType: 4,
                        name: "账户直发",
                        tips: "系统直接发送到账户",
                        used: true,
                        isSelect: false,
                    },
                    {
                        sendType: 5,
                        name: "短信发放",
                        tips: "兑换口令下发手机",
                        used: true,
                        isSelect: false,
                    },
                    {
                        sendType: 6,
                        name: "邮件推送",
                        tips: "敬请期待",
                        used: false,
                        isSelect: false,
                    },
                    {
                        sendType: 7,
                        name: "在线链接",
                        tips: "敬请期待",
                        used: false,
                        isSelect: false,
                    },
                    {
                        sendType: 8,
                        name: "api接口",
                        tips: "敬请期待",
                        used: false,
                        isSelect: false,
                    },
                ],
                columns,
                dataSource: [],
                columnsDown,
                dataDownloadList: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 10
                },
                pagination2: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 10
                },
                form: this.$form.createForm(this),
                formModal: this.$form.createForm(this),
                activeKey: 1,
                visible: false,
                dataDetail: {},
                maintitle: undefined,
                subtitle: undefined,
                type: undefined,
                loading: false,
                tableSelectedRowKeys: [],
                operateTitle: '',
                warningText: '',
                remark: undefined,
                visable: false,
                btnLoading: false,
                tableSelectedRows: [],
                orderDetail: {},
                couponId: "",
                shopList: [],
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {},
        methods: {
            /**
             * @getShopList 获取门店列表
             */
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    res.forEach((item,index) => {
                        item.label = item.name;
                        item.value = item.id;
                    });
                    this.shopList = [
                        {
                            label: "总部",
                            value: -1,
                        },
                        ...res
                    ];
                    this.getOrderDetail();
                });
            },
            handleReset() {
                this.form.resetFields();
            },
            getOrderDetail() {
                this.$api.changeCode.getOrderDetail({
                    query: {
                        orderId: this.$route.query.orderId,
                    }
                }).then( res => {
                    let shopName = this.shopList.find(el => el.value == res.saleShopId);
                    if (shopName) {
                        res.saleShopName = shopName.label;
                    } else {
                        res.saleShopName = "";
                    }
                    this.orderDetail = res;
                    this.couponId = res.couponId;
                    this.getDetail();
                    this.getList();
                    this.getOperationLog();
                });
            },
            search() {
                this.pagination.current = 1;
                if(this.activeKey == 3) {
                    this.getOperationLog()
                }else if(this.activeKey == 2) {
                    this.getList()
                }
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList()
            },
            changePage2(page) {
                this.pagination2.pageSize = page.pageSize;
                this.pagination2.current = page.current;
                this.getOperationLog()
            },
            getOperationLog() {
                this.$api.changeCode.operationLog({
                    body: {
                        shopId: this.shopId,
                        couponId: this.couponId,
                        groupOrderId: this.$route.query.orderId,
                        pageNum: this.pagination2.current,
                        pageSize: this.pagination2.pageSize,
                    }
                }).then( res => {
                    this.dataDownloadList = res.records;
                    this.pagination2.total = res.total;
                })
            },
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const validity = values['validity'] ? values['validity'] : []
                    values.startUseTime = validity.length > 0 ? validity[0].format('YYYY-MM-DD') : undefined
                    values.endUseTime = validity.length > 0 ? validity[1].format('YYYY-MM-DD') : undefined
                    delete values.validity

                    this.$api.changeCode.cashCodeList({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            groupId: this.$route.query.orderId,
                            id: this.couponId
                        })
                    })
                    .then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.records;
                    })
                });
            },
            getDetail() {
                this.$api.changeCode
                .exchangeGiftDetails({
                    query: {
                        id: this.couponId
                    }
                })
                .then(res => {
                    this.dataDetail = res;
                });
            },
            callback(key) {
                this.activeKey = key;
                if(this.activeKey == 3) {
                    this.getOperationLog()
                }else if(this.activeKey == 2) {
                    this.getList()
                }
            },
            tableSelectChange(tableSelectedRowKeys,tableSelectedRows) {
                this.tableSelectedRowKeys = tableSelectedRowKeys;
                this.tableSelectedRows = tableSelectedRows;
            },
            disableOrOpen(status, id, groupId) {
                this.visable = true;
                this.operateTitle = status ? '禁用' : '解禁';
                this.warningText = status ? '禁用操作，未兑换的兑换码将无法兑换' : '解禁操作，禁用的兑换码将继续可兑换';
                this.operateParams = {
                    ids: id,
                    isOpen: status,
                };
            },
            disableOrOpenBatch(status) {
                if(this.tableSelectedRowKeys.length == 0) {
                    this.$message.warning('选择不符合规范，请重新选择')
                    return
                }
                let flag1 = false;
                let flag2 = false;
                this.tableSelectedRows.forEach(item => {
                    if (status == -1) {
                        if(item.status == -1 || item.isUse == 1) {
                            flag1 = true
                        }
                    } else {
                        if(item.status == 0) {
                            flag2 = true
                        }
                    }
                })
                if(flag1) {
                    this.$message.warning('所选数据包含不可禁用，请重新选择')
                    return
                }
                if(flag2) {
                    this.$message.warning('所选数据包含不可解禁，请重新选择')
                    return
                }

                this.visable = true;
                this.operateTitle = status ? '禁用' : '解禁';
                this.warningText = status ? '禁用操作，未兑换的兑换码将无法兑换' : '解禁操作，禁用的兑换码将继续可兑换';
                this.operateParams = {
                    ids: this.tableSelectedRowKeys.join(','),
                    isOpen: status,
                };
            },
            handleOk() {
                this.operateParams.remark = this.remark;
                this.btnLoading = true;
                this.$api.changeCode.disableOrOpenBatch({
                    query: {...this.operateParams, groupId: this.$route.query.orderId}
                }).then(res => {
                    this.btnLoading = false;
                    this.visable = false;
                    this.remark = undefined;
                    this.tableSelectedRows = [];
                    this.tableSelectedRowKeys = [];
                    this.$message.success('操作成功');
                    this.getList();
                }).catch(err => {
                    this.btnLoading = false;
                })
            },
            cancel() {
                this.visible = false;
                this.formModal.resetFields();
            },
            exprotExcel() {
                if(this.tableSelectedRowKeys.length == 0) {
                    this.$message.warning('选择不符合规范，请重新选择')
                    return
                }
                this.btnLoading = true;
                this.$api.changeCode
                .exportCashCodeListById({
                    body: {ids: this.tableSelectedRowKeys}
                },
                {
                    responseType: "blob"
                })
                .then(res => {
                    let a = document.createElement("a");
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });

                    this.downloadUrl = window.URL.createObjectURL(blob);

                    let name = '兑换明细_' + this.$route.query.id + '_' + this.$moment().format('YYYYMMDDHHmmss') + '.xls';

                    a.setAttribute("href", this.downloadUrl);

                    var reportName = decodeURI(name);

                    a.setAttribute("download", reportName);
                    a.click();
                    this.btnLoading = false

                }).catch(err => {
                    this.btnLoading = false;
                });
            },
            exprotExcelAll() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const validity = values['validity'] ? values['validity'] : []
                    values.startUseTime = validity.length > 0 ? validity[0].format('YYYY-MM-DD') : ''
                    values.endUseTime = validity.length > 0 ? validity[1].format('YYYY-MM-DD') : ''
                    delete values.validity
                    
                    this.btnLoading = true;
                    this.$api.changeCode
                    .exportCashCodeList({
                        body: Object.assign(values, 
                        {   
                            pageNum: 1,
                            pageSize: 999999,
                            id: this.$route.query.id,
                            groupId: this.$route.query.orderId
                        })
                    },
                    {
                        responseType: "blob"
                    })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });

                        this.downloadUrl = window.URL.createObjectURL(blob);

                        let name = '兑换明细_' + this.$route.query.id + '_' + this.$moment().format('YYYYMMDDHHmmss') + '.xls';

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.btnLoading = false

                    }).catch(err => {
                        this.btnLoading = false;
                    });
                });
            },
        },
        beforeCreate() {},
        created() {
        },
        mounted() {
            this.getShopList();
        }
    };
</script>
<style lang="scss">
.exchangeGroupOrderDetail {
    .ant-form-item {
        margin-bottom: 16px;
        margin-left: 8px;
        margin-right: 0;
    }
    .ant-form-item-label {
        width: 84px;
    }
    .ant-form-item-control-wrapper {
        width: 282px;
    }
    &-tips {
        width: 100%;
        padding: 5px 10px;
        border-radius: 4px;
        border: 1px solid rgba(255, 229, 143, 1);
        background:rgba(255, 251, 230, 1);
        span:nth-of-type(n) {
            color: rgba(0,0,0,0.85);
        }
        span:nth-of-type(2n) {
            color: #ff6d33;
        }
    }
    &-exchangeMode {
        width: 11.8%;
        border: 1px solid #EEE;
        padding: 15px 0;
        border-radius: 10px;
        cursor:pointer;
        &:last-child {
            margin-right: 0;
        }
        &.isSelect {
            // background: #ff6d33;
            border: 1px solid #ff6d33;
            // color: #FFF;
        }
    }
}
</style>